import { z } from 'zod';

export const BROWSER_RECORDINGS_KEY_PREFIX = 'browser-recordings';

export const BROWSER_RECORDING_MIME_TYPE = 'video/webm';

export const BROWSER_RECORDING_THUMBNAIL_MIME_TYPE = 'image/webp';

export const BROWSER_RECORDING_THUMBNAIL_MAX_BYTES = 48 * 1024;

export const BROWSER_RECORDING_THUMBNAIL_DATA_URI_PREFIX = `data:${BROWSER_RECORDING_THUMBNAIL_MIME_TYPE};base64,`;

const BrowserRecordingStorageKeySchema = z
  .string()
  .startsWith(`${BROWSER_RECORDINGS_KEY_PREFIX}/`);

export const BrowserRecordingRefSchema = z.object({
  storageKey: BrowserRecordingStorageKeySchema,
  thumbnailStorageKey: BrowserRecordingStorageKeySchema.optional(),
  browserSessionId: z.string().min(1),
  toolCallId: z.string().min(1),
  mimeType: z.literal(BROWSER_RECORDING_MIME_TYPE),
  status: z.literal('pending'),
});

export const BrowserRecordingThumbnailSchema = z
  .string()
  .startsWith(BROWSER_RECORDING_THUMBNAIL_DATA_URI_PREFIX)
  .max(
    BROWSER_RECORDING_THUMBNAIL_DATA_URI_PREFIX.length +
      Math.ceil(BROWSER_RECORDING_THUMBNAIL_MAX_BYTES / 3) * 4,
  );

export const BrowserRecordingArtifactMetadataSchema = z.object({
  recording: BrowserRecordingRefSchema,
  recordingThumbnail: BrowserRecordingThumbnailSchema.optional(),
});

export const BrowserRecordingUrlResponseSchema = z.object({
  signedUrl: z.string(),
  mimeType: z.literal(BROWSER_RECORDING_MIME_TYPE),
  expiresAt: z.coerce.date(),
});

export const BROWSER_SCREENSHOT_MIME_TYPE = 'image/jpeg';

export const BrowserScreenshotRefSchema = z.object({
  storageKey: BrowserRecordingStorageKeySchema,
  mimeType: z.literal(BROWSER_SCREENSHOT_MIME_TYPE),
});

export const BrowserScreenshotArtifactMetadataSchema = z.object({
  screenshot: BrowserScreenshotRefSchema,
});

export const BrowserScreenshotUrlResponseSchema = z.object({
  signedUrl: z.string(),
  mimeType: z.literal(BROWSER_SCREENSHOT_MIME_TYPE),
  expiresAt: z.coerce.date(),
});
